// extracted by mini-css-extract-plugin
var _1 = "RequestProfileTabActivitiesPhaseList-moduleRequestProfileTabActivitiesPhaseList__iXBjb";
var _2 = "RequestProfileTabActivitiesPhaseList-moduleinsertable__nfdQ2";
export { _1 as "RequestProfileTabActivitiesPhaseList", _2 as "insertable" }
